<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="140px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="商品列表" prop="productList">
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addProduct(null)"
          >
            增加商品
          </el-button>
          <el-table stripe :data="form.productList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="标题"
              prop="productName"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="价格"
              prop="price"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="数量"
              prop="count"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="120px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delProduct($index)">删除</el-button>
                <!-- <el-button type="text" @click="editProduct($index)">编辑</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="总价格">
          <el-input
            v-model="totalPrice"
            class="fix-width"
            :disabled="true"
          />
        </el-form-item>
        <el-form-item label="详情图片" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="支付成功图片" prop="paymentSuccessImageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.paymentSuccessImageList"
            :on-success="paymentSuccessImageList_success"
            :on-remove="paymentSuccessImageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="购买弹窗描述项目" prop="itemList">
          <el-button
            type="primary"
            size="mini"
            class="mb-10"
            @click="addDesc(null)"
          >
            增加
          </el-button>
          <el-table stripe :data="form.itemList">
            <el-table-column align="left" label="序号" width="55">
              <template #default="{ $index }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="图片"
              prop="key"
              show-overflow-tooltip
            >
              <template #default="{ row }">
                <img :src="row.avatar" class="avatar" />
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="标题"
              prop="title"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              label="数量"
              prop="count"
              show-overflow-tooltip
            />
            <el-table-column
              align="left"
              fixed="right"
              label="操作"
              show-overflow-tooltip
              width="120px"
            >
              <template #default="{ $index }">
                <el-button type="text" @click="delDesc($index)">删除</el-button>
                <el-button type="text" @click="editDesc($index)">
                  编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="倒计时" prop="clockTime">
          <el-time-picker v-model="form.clockTime" placeholder="倒计时" value-format="HH:mm:ss" />
        </el-form-item>
        <el-form-item label="openApiKey">
          <el-input v-model="form.openApiKey" class="fix-width" placeholder="api密钥，选填" />
        </el-form-item>
        <el-form-item label="wxAppId" prop="wxAppId">
          <el-input v-model="form.wxAppId" class="fix-width" placeholder="wxAppId，必填" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="descFormVisible"
      :close-on-click-modal="false"
      title="购买弹窗描述项目"
      width="600px"
      @close="descClose"
    >
      <el-form
        ref="descForm"
        label-width="120px"
        :model="descForm"
        :rules="descFormRules"
      >
        <el-form-item label="图片" prop="avatar">
          <el-upload
            :multiple="false"
            :limit="1"
            :class="{ disabled: descForm.avatar.length > 0 }"
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="descForm.avatar"
            :on-success="avatar_success"
            :on-remove="avatar_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="descForm.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="数量" prop="count">
          <el-input v-model="descForm.count" placeholder="请输入数量" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="descClose">取 消</el-button>
        <el-button type="primary" @click="descSave">确 定</el-button>
      </template>
    </el-dialog>
    <el-dialog
      v-model="productFormVisible"
      :close-on-click-modal="false"
      title="增加商品"
      width="800px"
      @close="productClose"
    >
      <el-form
        ref="productForm"
        label-width="120px"
        :model="productForm"
        :rules="productFormRules"
      >
        <el-form-item label="选择商品" prop="productName">
          <el-autocomplete
            v-model="productForm.productName"
            :fetch-suggestions="querySearchAsync"
            placeholder="查询商品"
            @select="productSelect"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="数量" prop="count">
          <el-input-number
            v-model="productForm.count"
            placeholder="请输入数量"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="productClose">取 消</el-button>
        <el-button type="primary" @click="productSave">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createPage, updatePage, findProductAll } from '@/api/shop'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'TiktokEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      form: {
        pageId: '',
        title: '',
        productList: [],
        paymentSuccessImageList: [],
        imageList: [],
        clockTime: '',
        itemList: [],
        openApiKey: '',
        wxAppId:'',
        order: 1,
      },
      descForm: {
        index: null,
        avatar: [],
        title: '',
        count: 1,
      },
      productForm: {
        productId: '',
        productName: '',
        price:'',
        count: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        productList: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请至少选择一件商品'))
              } else {
                callback()
              }
            },
          },
        ],
        itemList:[
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请至少增加一件描述项目'))
              } else {
                callback()
              }
            },
          },
        ],
        clockTime: [
          { required: true, trigger: 'blur', message: '请选择抢购倒计时' },
        ],
        wxAppId:[{ required: true, trigger: 'blur', message: '请填写wxAppId' }]
      },
      descFormRules: {
        count: [{ required: true, trigger: 'blur', message: '数量最小为1' }],
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
      },
      productFormRules: {
        count: [{ required: true, trigger: 'blur', message: '数量最小为1' }],
        productId: [
          { required: true, trigger: 'blur', message: '请至少选择一件商品' },
        ],
        productName:[{ required: true,}]
      },
      dialogFormVisible: false,
      descFormVisible: false,
      productFormVisible: false,
    }
  },
  computed:{
    totalPrice(value) {
      const price = this.form.productList.reduce((total,item)=>total + item.price * item.count,0)
      console.log('price',price)
      return price
    }
  },
  methods: {
    addDesc() {
      this.descFormVisible = true
    },
    addProduct() {
      this.productFormVisible = true
    },
    descSave() {
      this.$refs['descForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.descForm)
          form.avatar = form.avatar[0] && form.avatar[0].url
          const index = form.index
          delete form.index
          if (index != null) {
            this.form.itemList.splice(index, 1, form)
          } else {
            this.form.itemList.push(form)
          }
          this.descClose()
        } else {
          return false
        }
      })
    },
    productSave() {
      this.$refs['productForm'].validate(async (valid) => {
        if (valid) {
          const form = Object.assign({}, this.productForm)
            this.form.productList.push(form)
          this.productClose()
        } else {
          return false
        }
      })
    },
    editDesc(index) {
      const form = Object.assign({}, this.form.itemList[index])
      form.avatar = [{ url: form.avatar }]
      form.index = index
      this.descForm = Object.assign({}, form)
      this.descFormVisible = true
    },
    delDesc(index) {
      this.form.itemList.splice(index, 1)
    },
    delProduct(index) {
      this.form.productList.splice(index, 1)
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改抖音落地页'
        this.form = Object.assign(this.form, row.basic)
        this.form.pageId = row.pageId
        this.form.title = row.title
      } else {
        this.title = '新增抖音落地页'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      this.uploadToken = { token: token.token }
    },
    // 图片
    imageList_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    paymentSuccessImageList_remove(file, fileList) {
      this.form.paymentSuccessImageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    avatar_remove(file, fileList) {
      this.descForm.avatar = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    paymentSuccessImageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.paymentSuccessImageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    avatar_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.descForm.avatar.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    imageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    descClose() {
      this.$refs['descForm'].resetFields()
      this.descForm = this.$options.data().descForm
      this.descFormVisible = false
    },
    productClose() {
      this.$refs['productForm'].resetFields()
      this.productForm = this.$options.data().productForm
      this.productFormVisible = false
    },
    async querySearchAsync(keyword,cb) {
      const ret = await findProductAll({
        keyword,
      })
      cb(
        ret.map((e) => ({
          value: `${e.title}`,
          productId: e.productId,
          price:e.basic.price
        }))
      )
    },
    productSelect(item) {
      this.productForm.productId = item.productId
      this.productForm.productName = item.value
      this.productForm.price = item.price
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const pageId = this.form.pageId
          //处理数据
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${pageId ? '修改' : '新增'}抖音落地页吗`,
            null,
            async () => {
              pageId ? await updatePage(data) : await createPage(data)
              this.$baseMessage(
                `${pageId ? '修改' : '新增'}抖音落地页成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss">
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
